module.exports = __webpack_public_path__ + "img/stack-overflow.f13bbfa5.png";